import PaymentsInterstitialModal from '../components/PaymentsInterstitialModal';
import { useCallback, useState } from 'react';
import PaymentsEmbedPointContext from './PaymentsEmbedPointContext';
import { DISABLED_MODALS, Screen } from '../types/screen';
import { ModalDisplay } from '../types/paymentsInterstitialModal';
import TrackRender from '../tracking/TrackRender';
import { events } from '../tracking/events';
import { useEmbedPointModalDisplay } from '../hooks/useEmbedPointModalDisplay';
import useCommerceEnrollmentStatus from '../hooks/toolStatus/useCommerceEnrollmentStatus';
import { getToolTrackingStatus } from '../utils/toolTrackingStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentsEmbedPointContextProvider = ({
  children,
  screen,
  subscreen,
  appName
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const display = useEmbedPointModalDisplay({
    screen,
    subscreen
  });
  const {
    toolUsage
  } = useCommerceEnrollmentStatus();
  const toolStatus = getToolTrackingStatus(toolUsage);

  /**
   * Wraps the behavior so the behavior can be overridden to show a modal.
   *
   * Example usage:
   * const shouldDisableCallbackOnModalDisplay = true;
   * const callback = () => {
   *   // stuff the user action normally does when click happens
   * }
   *
   * onClick={getPaymentsInterstitialModalOpenHandler(callback, shouldDisableNormalBehavior)}
   */
  const getPaymentsInterstitialModalOpenHandler = useCallback((callback = () => {}, shouldDisableCallbackOnModalDisplay = false) => e => {
    setIsModalOpen(true);
    if (shouldDisableCallbackOnModalDisplay && display !== ModalDisplay.NONE) return undefined;
    return callback(e);
  }, [setIsModalOpen, display]);
  const providedProps = {
    getPaymentsInterstitialModalOpenHandler
  };
  const disabledModals = DISABLED_MODALS[screen] || [];
  const shouldTrackRender = screen !== Screen.CRM;
  return /*#__PURE__*/_jsxs(PaymentsEmbedPointContext.Provider, {
    value: providedProps,
    children: [typeof children !== 'function' ? children : children(providedProps), !disabledModals.includes(display) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PaymentsInterstitialModal, {
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        display: display,
        screen: screen,
        subscreen: subscreen,
        appName: appName,
        toolStatus: toolStatus
      }), shouldTrackRender && /*#__PURE__*/_jsx(TrackRender, {
        event: events.embedPointsPageView,
        properties: {
          screen,
          subscreen,
          displayType: display,
          toolStatus
        }
      })]
    })]
  });
};
export default PaymentsEmbedPointContextProvider;